/**
 * Insurer legal identity for the NDDP disclosures (TIMB, Ansa-Support#30).
 *
 * TIMB's requirement is that the underwriter be named by its REGISTERED LEGAL NAME with
 * its company number, alongside a statement of who distributes the product and under what
 * authority: "Display of the Tune Protect logo only as insurer/underwritten by is
 * insufficient."
 *
 * The legal name itself lives in `insurer-name.js` (`getInsurerName`) and is keyed on the
 * same internal routing key the quote API uses — `TUNE PROTECT` — which is never rendered.
 * This file adds the company numbers.
 *
 * Company numbers are only ever set from a number the insurer itself gave us. An insurer
 * with no entry here renders its legal name with no number line, never a guessed one.
 */

const companyNumbers = {
	// Given by Tune Insurance Malaysia Berhad in the NDDP test script on Ansa-Support#30.
	"TUNE PROTECT": "197601004719 (30686-K)",
	// Given by Liberty; already shown on the plan card for Liberty quotes.
	LIBERTY: "197801007153 (44191-P)",
};

/** Company registration number for an insurer, or null when we do not hold one. */
export const getInsurerCompanyNo = (insurerName) =>
	companyNumbers[insurerName] || null;

/**
 * The distributor statement. Advance Fin Advisory Sdn Bhd is the licensed entity behind
 * the platform; the same sentence already appears on the plan list and in the terms.
 */
export const DISTRIBUTOR_STATEMENT =
	"distributed by Advance Fin Advisory Sdn Bhd as the authorised Financial Advisor registered with BNM.";
